'use client';
import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { generateRoomId } from '@/lib/client-utils';
import { CONFIG } from '@/lib/config';

interface NiroProps {
  data: {
    userName: string;
    userEmail: string;
    userCompany: string;
    userWebsite: string;
    userPhone?: string;
    userPostcode?: string;
  };
  id: keyof typeof CONFIG;
}

export default function Niro({ data }: NiroProps) {
  const router = useRouter();

  useEffect(() => {
    const roomId = generateRoomId();
    const meetingUrl = `${window.location.origin}/rooms/${roomId}`;
    const params = new URLSearchParams({
      ai: 'niro',
      userName: data.userName,
      userEmail: data.userEmail,
      userCompany: data.userCompany,
      userWebsite: data.userWebsite || '',
      meetingUrl,
      ...(data.userPhone && { userPhone: data.userPhone }),
      ...(data.userPostcode && { userPostcode: data.userPostcode }),
    });
    router.push(`/rooms/${roomId}?${params.toString()}`);
  }, [data, router]);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-sand">
      <div className="flex flex-col items-center gap-6">
        <div className="relative w-20 h-20">
          <div
            className="absolute inset-0 rounded-full border-2 border-dune/30 animate-spin"
            style={{ animationDuration: '2.5s' }}
          />
          <div
            className="absolute inset-2 rounded-full border-2 border-stone/40 animate-spin"
            style={{ animationDuration: '3.5s', animationDirection: 'reverse' }}
          />
          <img
            src="/leo.png"
            alt="Leo"
            className="absolute inset-3 w-[calc(100%-24px)] h-[calc(100%-24px)] rounded-full object-cover"
          />
        </div>
        <div className="text-center">
          <p className="text-coal font-medium text-sm">Connecting to Leo</p>
          <p className="text-ash/60 text-xs mt-1">Setting up your meeting...</p>
        </div>
      </div>
    </div>
  );
}
